import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

import WizardInput from "./WizardInput";

const BillingUserForm = ({ register, errors, setValue }) => {
  return (
    <>
      <Row className="g-2 mb-3">
        <WizardInput
          type="number"
          errors={errors}
          label="Card Number *"
          name="cardNumber"
          placeholder="•••• •••• •••• ••••"
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            className: "input-spin-none",
            ...register("cardNumber", {
              required: "Please Enter your card number",
            }),
          }}
        />
        <WizardInput
          errors={errors}
          label="Name on Card*"
          name="nameOnCard"
          placeholder="John Doe"
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register("nameOnCard", {
              required: "Name on card is requred",
            }),
          }}
        />
      </Row>

      <Row className="g-2 mb-3">
        <WizardInput
          type="select"
          name="country"
          label="Country"
          errors={errors}
          placeholder="Select your country"
          options={[
            "Afghanistan",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bosnia and Herzegowina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Congo, the Democratic Republic of the",
            "Cook Islands",
            "Costa Rica",
            "Cote d'Ivoire",
            "Croatia (Hrvatska)",
            "Cuba",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "East Timor",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands (Malvinas)",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "France Metropolitan",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Heard and Mc Donald Islands",
            "Holy See (Vatican City State)",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran (Islamic Republic of)",
            "Iraq",
            "Ireland",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea, Democratic People's Republic of",
            "Korea, Republic of",
            "Kuwait",
            "Kyrgyzstan",
            "Lao, People's Democratic Republic",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libyan Arab Jamahiriya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macau",
            "Macedonia, The Former Yugoslav Republic of",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Micronesia, Federated States of",
            "Moldova, Republic of",
            "Monaco",
            "Mongolia",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "Netherlands Antilles",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Reunion",
            "Romania",
            "Russian Federation",
            "Rwanda",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Slovakia (Slovak Republic)",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "South Georgia and the South Sandwich Islands",
            "Spain",
            "Sri Lanka",
            "St. Helena",
            "St. Pierre and Miquelon",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen Islands",
            "Swaziland",
            "Sweden",
            "Switzerland",
            "Syrian Arab Republic",
            "Taiwan, Province of China",
            "Tajikistan",
            "Tanzania, United Republic of",
            "Thailand",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "United States",
            "United States Minor Outlying Islands",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Venezuela",
            "Vietnam",
            "Virgin Islands (British)",
            "Virgin Islands (U.S.)",
            "Wallis and Futuna Islands",
            "Western Sahara",
            "Yemen",
            "Yugoslavia",
            "Zambia",
            "Zimbabwe",
          ]}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register("country", {
              required: "Select a country",
            }),
          }}
        />

        <WizardInput
          type="number"
          name="zipCode"
          label="Zip Code*"
          placeholder="1234"
          errors={errors}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            className: "input-spin-none",
            ...register("zipCode", {
              required: "Zip code is requred",
            }),
          }}
        />
      </Row>

      <Row className="g-2 mb-3">
        <WizardInput
          label="Exp Date*"
          type="date"
          name="expDate"
          setValue={setValue}
          errors={errors}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            placeholder: "MM/YYYY",
            ...register("expDate", {
              required: "Exp date is requred.",
            }),
          }}
          datepickerProps={{
            dateFormat: "MM/yyyy",
            showMonthYearPicker: true,
          }}
        />
        <WizardInput
          label={
            <>
              CVV*
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ position: "fixed" }}>
                    Card verification value
                  </Tooltip>
                }
              >
                <span>
                  <FontAwesomeIcon icon="question-circle" className="mx-2" />
                </span>
              </OverlayTrigger>
            </>
          }
          type="number"
          name="cvv"
          placeholder="123"
          errors={errors}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            className: "input-spin-none",
            ...register("cvv", {
              required: "CVV is requred",
              maxLength: {
                value: 3,
                message: "cvv must have at max 3 characters",
              },
            }),
          }}
        />
      </Row>
    </>
  );
};

BillingUserForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
};

export default BillingUserForm;
